import { BinModel } from "../models/BinsModel";

export const initialBinss: BinModel[] = [
  new BinModel("A001", "001", 15, 5, true, "EM-12MM-4F"),
  new BinModel("A002", "001", 20, 5, true, "7712A11"),
  new BinModel("A003", "001", 25, 5, true, "9150F44"),
  new BinModel("A004", "001", 5, 30, true, "H9289"),
  new BinModel("A005", "001", 40, 20, true, "EM-10MM-4F"),
  new BinModel("A006", "001", 50, 20, true, "EM-6MM-2F"),
  new BinModel("A007", "001", 40, 20, true, "EM-12MM-4F"),
  new BinModel("A008", "001", 2, 30, true, "DR-5MM-HSS"),
  new BinModel("A009", "001", 60, 40, true, "DR-10MM-COBALT"),
  new BinModel("A010", "001", 13, 40, true, "DR-3MM-HSS"),
  new BinModel("A011", "001", 40, 20, true, "SF-HSK63A-1IN"),
  new BinModel("A111", "001", 40, 20, true, "SF-HSK63A-1IN"),
  new BinModel("A012", "001", 3, 20, true, "SF-BT40-12MM"),
  new BinModel("A013", "001", 15, 10, true, "84CutDia"),
  new BinModel("A014", "001", 10, 5, true, "4cutdia"),
  new BinModel("A015", "001", 10, 5, true, "FM-125MM-10T"),
  new BinModel("A016", "001", 15, 5, true, "153KJ83"),
  new BinModel("A017", "001", 10, 5, true, "8821B55"),
  new BinModel("A018", "001", 50, 20, true, "5533C77"),
  new BinModel("A019", "001", 12, 5, true, "9912D88"),
  new BinModel("A020", "001", 10, 5, true, "1100E22"),
  new BinModel("A021", "001", 40, 15, true, "6677F99"),
  new BinModel("A022", "001", 20, 5, true, "2244G11"),
  new BinModel("A023", "001", 0, 6, true, "GW-8X1-60G"),
  new BinModel("A024", "001", 0, 30, true, "MP-1IN-60G"),
  new BinModel("C001", "001", 29, 30, true, "CL-123"),
];